<template>
  <div class="steps-bar">
    <div
      v-for="(title, index) in steps"
      :key="title"
      class="step"
      :class="{'step--active': index + 1 <= currentStep}"
    >
      <div class="step__content">
        <div
          class="step__content-line"
        ></div>
        <div class="step__content-circle">
          <span>
            {{ index + 1 }}
          </span>
        </div>
        <div
          class="step__content-line"
        ></div>
      </div>

      <span class="step__title">
        {{ title }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepsBar',
  props: {
    currentStep: {
      required: true,
      type: Number
    },
    steps: {
      required: true,
      type: Array
    }
  }
};
</script>

<style src="@/assets/css/components/stepsBar.css" />
